var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseService } from "./base.service";
export class CustomerService extends BaseService {
    constructor(ellCommerce) {
        super(ellCommerce, "customer");
    }
    getLoginSSOUrl(userId, countryISO2, redirectUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            const iso2 = this.getCountryISO2(countryISO2);
            const redirectParam = !redirectUrl
                ? ""
                : `?redirectUrl=${encodeURIComponent(redirectUrl)}`;
            try {
                const response = yield this.api.request({
                    url: `customers/user/${userId}/country/${iso2}/login${redirectParam}`,
                    method: "GET",
                });
                return response.data;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
    postLoginEvent(userId, countryISO2) {
        return __awaiter(this, void 0, void 0, function* () {
            const iso2 = this.getCountryISO2(countryISO2);
            try {
                const response = yield this.api.request({
                    url: `customers/user/${userId}/country/${iso2}/event/login`,
                    method: "POST",
                    data: null,
                });
                return (response === null || response === void 0 ? void 0 : response.status) === 200;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
    postLogoutEvent(userId, countryISO2) {
        return __awaiter(this, void 0, void 0, function* () {
            const iso2 = this.getCountryISO2(countryISO2);
            try {
                const response = yield this.api.request({
                    url: `customers/user/${userId}/country/${iso2}/event/logout`,
                    method: "POST",
                    data: null,
                });
                return (response === null || response === void 0 ? void 0 : response.status) === 200;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
    postPasswordChangeEvent(userId, passwordChangeEventRequest, countryISO2) {
        return __awaiter(this, void 0, void 0, function* () {
            const iso2 = this.getCountryISO2(countryISO2);
            try {
                const response = yield this.api.request({
                    url: `customers/user/${userId}/country/${iso2}/event/passwordchange`,
                    method: "POST",
                    data: passwordChangeEventRequest,
                });
                return (response === null || response === void 0 ? void 0 : response.status) === 200;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
}
